import React , {useState} from 'react'
// import CV from'../../assets/MURAD ISSA.docx';
import MEImage from '../../assets/murad3.jpg'
import {BsLinkedin,BsGithub} from "react-icons/bs";
import "./header.css"
import PopupCV from './popup/PopupCV';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const togglePopup = () => {
    setIsOpen(!isOpen);
  }
  return (
    <>
      <header>
        <div className="container header__container">
          <h3>Hello I'm</h3>
          <h1>Murad Issa</h1>
          <h3 className="text-light">FullStack Developer</h3>
          <div className='cta'>
            <a className='btn' onClick={()=> togglePopup()}>Request Resume</a>
            <a className='btn btn-primary' href='#contact'>Let's Talk</a>
          </div>
          <div className='header__socials'>
            <a href="https://www.linkedin.com/in/murad-eissa-0b953318a/" target="_blank"><BsLinkedin/></a>
            <a href="https://github.com/muradissa" target="_blank"><BsGithub/></a>
          </div>
          <div className='me'>
            <img src={MEImage} alt="me"/>
          </div>
          <a href="#contact" className='scroll__down'>Scroll Down</a>
        </div>
      </header>
      { isOpen && 
        <PopupCV
            handleClose={togglePopup}
        />
      }
    </>
  )
}

export default Header